import React, { useState, useEffect, Fragment } from 'react';
import cogoToast from 'cogo-toast';
import DatePicker from 'react-datepicker';
import ButtonIcon from '../../components/common/ButtonIcon';
import PageHeader from '../../components/common/PageHeader';
import DetailRow from '../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import ExampleCustomInput from '../../components/input/ExampleCustomInput';
import { urlApi } from '../../configuracion/serverConfig';
import { headers } from "../../helpers/authSesion";
import { formatDate } from '../../helpers/dateFormatters';
import { CeldaValor } from '../../helpers/tablaInforme';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';


const RegContable = () => {

  const [data, setData] = useState([]);
  const [dateRange, setDateRange] = useState([new Date(new Date().setDate(new Date().getDate() - 1)), new Date()]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (!dateRange || !startDate || !endDate) return;
    load();
  }, dateRange)

  const exportar = (desembolso) => {
    window.open(`${urlApi}/informe/desembolso/excel/${desembolso}`, "_blank");
  };

  const getDesembolsos = () => {
    return fetch(`${urlApi}/informe/desembolsos/${formatDate(startDate)}/${formatDate(endDate)}`, {
      method: 'POST',
      headers,
    }).then(res => res.json())
      .then(data => data)
      .then(data => {
        return data.status === 0 ? data : { error: true, msg: data.objError.msgError }
      }).catch(err => {
        console.log("Error", err);
        return { error: true, msg: "ERROR" }
      });
  };

  const load = async () => {
    const response = await getDesembolsos();
    if (response.error) {
      cogoToast.error(response.msg, { position: 'bottom-right', heading: 'Error en la respuesta' });
      return;
    }
    const res = response.objResponse;
    setData(res);
  };

  return (
    <Fragment>
      <PageHeader
        title="Registro contable"
        className="mb-3"
      />
      <Card className={`my-3`} >
        <CardBody className="px-4">
          <Row>
            <Col lg={3} className="mx-2">
              <DetailRow title="Rango de Fechas">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selectsRange={true}
                  locale="es"
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  customInput={<ExampleCustomInput />}
                />
              </DetailRow>
            </Col>
            <Col lg={1} className="mx-2">
              <DetailRow title="-" titleClass="text-white">
                <Button onClick={load} transform="shrink-3 down-2" color="primary" >
                  Buscar
                </Button>
              </DetailRow>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className={`my-3`} >
        <CardBody className="px-4 table-responsive">
          <table
            className="table table-dashboard table-striped table-sm fs--1 border-bottom border-200 mb-0 table-dashboard-th-nowrap">
            <tbody>
              <tr>
                <th style={{ textAlign: "center", verticalAlign: "middle" }}>FECHA DESEMBOLSO</th>
                <th style={{ textAlign: "center", verticalAlign: "middle" }}>FECHA DE SOLICITUD</th>
                <th style={{ textAlign: "center", verticalAlign: "middle" }}>NUMERO DE SOLICITUD</th>
                <th style={{ textAlign: "center", verticalAlign: "middle" }}>NUMERO DEL CREDITO</th>
                <th style={{ textAlign: "center", verticalAlign: "middle" }}>BENEFICIARIO</th>
                <th style={{ textAlign: "center", verticalAlign: "middle" }}>MONTO SOLICITADO</th>
                <th style={{ textAlign: "center", verticalAlign: "middle" }}></th>
              </tr>
              {data.map(i => <tr key={i.desembolso}>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{i.fecha}</td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{i.fecha_sol}</td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{i.solicitud}</td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{i.credito}</td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{i.nomcliente}</td>
                <CeldaValor valor={i.monto} style={{ verticalAlign: "middle" }} />
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  <ButtonIcon onClick={() => exportar(i.desembolso)} icon="file-excel" transform="shrink-3 down-2" color="falcon-default" size="sm">
                  </ButtonIcon>
                </td>
              </tr>)}
            </tbody>
          </table>
        </CardBody>
      </Card>
    </Fragment>
  );
}

export default RegContable;
